// Query-cache helpers shared by the Market tab's panels and its auto-run (Story #6837).
import type { QueryClient } from '@tanstack/react-query'

/**
 * Refresh everything on screen that is derived from one project's market data: its own view, and the
 * sector lists the Atlas Sector lens and the aggregator Sector view read (both live under ['market-sectors']).
 * Returns the refresh promise so a mutation can stay pending until fresh data has arrived: a second edit made
 * in the meantime would otherwise be planned from the list the first edit just changed.
 */
export function invalidateMarket(qc: QueryClient, projectId: string): Promise<unknown> {
  return Promise.all([
    qc.invalidateQueries({ queryKey: ['market', projectId] }),
    qc.invalidateQueries({ queryKey: ['market-sectors'] }),
  ])
}
